import React, { useState, useEffect } from 'react';
import { KeyRound, Copy, CheckCircle2, AlertCircle } from 'lucide-react';

const API_URL = process.env.REACT_APP_API_URL || (window.location.origin + '/api');

export default function RevealPassword() {
  const [state, setState] = useState({ loading: true });
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get('token');
    if (!token) { setState({ error: 'Falta el token del link.' }); return; }
    fetch(`${API_URL}/directory/public/password/${encodeURIComponent(token)}`)
      .then(async r => {
        const j = await r.json().catch(() => ({}));
        if (r.ok) setState({ upn: j.upn, password: j.password });
        else setState({ error: j.error || 'Link inválido o expirado.' });
      })
      .catch(() => setState({ error: 'No se pudo contactar el servidor.' }));
  }, []);

  const copy = () => { navigator.clipboard?.writeText(state.password); setCopied(true); setTimeout(() => setCopied(false), 2000); };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--ink)', padding: 20 }}>
      <div style={{ background: 'var(--surface)', borderRadius: 14, padding: '28px 32px', width: 460, maxWidth: '92vw', textAlign: 'center' }}>
        <div style={{ width: 48, height: 48, borderRadius: '50%', background: 'var(--accent-dim)', color: 'var(--accent)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px' }}><KeyRound size={24} /></div>
        <div style={{ fontSize: 18, fontWeight: 700, color: 'var(--ink)' }}>Contraseña temporal</div>

        {state.loading && <div style={{ color: 'var(--ink-2)', marginTop: 14 }}>Cargando…</div>}

        {state.error && (
          <div style={{ marginTop: 16, background: 'var(--red-dim)', color: 'var(--red)', borderRadius: 8, padding: '12px 14px', fontSize: 14, display: 'flex', gap: 8, alignItems: 'center', justifyContent: 'center' }}>
            <AlertCircle size={16} /> {state.error}
          </div>
        )}

        {state.password && (
          <>
            <div style={{ fontSize: 13, color: 'var(--ink-2)', marginTop: 6 }}>{state.upn}</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, justifyContent: 'center', marginTop: 16, background: 'var(--bg-subtle)', border: '1px solid var(--border)', borderRadius: 10, padding: '14px 16px' }}>
              <span style={{ fontFamily: 'monospace', fontSize: 20, letterSpacing: 1, color: 'var(--ink)' }}>{state.password}</span>
              <button onClick={copy} style={{ font: 'inherit', border: '1px solid var(--border)', background: 'var(--surface)', borderRadius: 8, padding: '6px 10px', cursor: 'pointer', display: 'flex', gap: 5, alignItems: 'center', fontSize: 13 }}>
                {copied ? <><CheckCircle2 size={14} color="var(--green)" /> Copiado</> : <><Copy size={14} /> Copiar</>}
              </button>
            </div>
            <div style={{ marginTop: 16, background: 'var(--amber-dim)', color: '#854d0e', borderRadius: 8, padding: '10px 12px', fontSize: 12.5, lineHeight: 1.5 }}>
              Este link es de <b>un solo uso</b> y ya no volverá a mostrar la contraseña. Guardala ahora. El usuario deberá cambiarla en el primer inicio de sesión.
            </div>
          </>
        )}
      </div>
    </div>
  );
}
